import { schema } from 'normalizr';

const user = new schema.Entity(
  'users',
  {},
  {
    idAttribute: 'id',
  },
);

const comment = new schema.Entity(
  'comments',
  {
    author: user,
  },
  {
    idAttribute: 'id',
  },
);

const review = new schema.Entity(
  'reviews',
  {
    comments: [comment],
    author: user,
  },
  {
    idAttribute: 'id',
  },
);

export { review, comment, user };
